import React, { useLayoutEffect, useEffect  } from "react";
import { Link } from "react-router-dom";
import { Container, Grid, Box, Button } from '@material-ui/core';
import protocolBanner01 from '../../assets/images/Band-Protocol-Graphic.png';
import protocolBanner02 from '../../assets/images/Pancake-Swap-Graphic.png';
import './Protocol.css';
import AOS from 'aos';

function Protocol() {
	useEffect(() => {
		AOS.init({
			disable: 'mobile'
		  });
	});
	return (
		<section className="section-spacing" id="protocol">
			<Container maxWidth="lg" className="main-container text-white">
				<Grid container spacing={7}>
					<Grid item xs={12}>
						<Box data-aos="fade-up" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200" textAlign="center" className="section-heading text-uppercase">
							<h2>Decentralized protocol integration</h2>
						</Box>
					</Grid>
					<Grid item md={6} xs={12}>
						<Box data-aos="flip-right" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200" className="protocol-box">
							<Box className="protocol-banner">
								<img className="img-fluid" src={protocolBanner01} alt="Feature Icon" />
							</Box>
							<Box className="protocol-text-block">
								<p>xWin integrated on-chain price feeds with band protocol.</p>
								<p>The price is used for:</p>
								<ol>
									<li>Evaluating the vaults total value for unit price</li>
									<li>Price impact tolerance validation during swapping on Pancakeswap to avoid unfair price tolerance.</li>
								</ol>
							</Box>
						</Box>
					</Grid>
					<Grid item md={6} xs={12}>
						<Box data-aos="flip-left" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200" className="protocol-box">
							<Box className="protocol-banner">
								<img className="img-fluid" src={protocolBanner02} alt="Feature Icon" />
							</Box>
							<Box className="protocol-text-block">
								<p>PancakeSwap protocol is integrated in xWin for all the swapping activities from BNB to Tokes or Tokens to BNB in index vaults. Only the sufficient liquidity pair will be included into xWin vaults.</p>
							</Box>
							<Box className="protocol-text-block">
								<p>Pancake Liquidity Pool and Farm are also being integrated into xWin LP vault. It makes liquidity provider process easier than ever.</p>
							</Box>
						</Box>
					</Grid>
					<Grid item xs={12}>
						<Box textAlign="center" className="footer-btns-holder">
							<Button data-aos="fade-right" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200" variant="contained" color="primary">Launch the App</Button>
							<Button data-aos="fade-left" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200" variant="contained" color="secondary">xWin Docs</Button>
						</Box>
					</Grid>
				</Grid>
			</Container>
		</section>
	);
}
export default Protocol;